import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Spinner from '../../components/Spinner';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { FaReceipt } from 'react-icons/fa';
import { formatDate, formatNumber } from '../../utils/functions';
import { pageModel } from '../../utils/model';
import { ORDER_PATH, chargeOrder, dechargeOrder, downloadNewOrderReceipt, downloadOrderReceipt, uploadOrderExcelFile } from '../../api/orderApi';
import { getPageOrders } from '../../api/orderApi';
import { deleteOrder } from '../../api/orderApi';
import { FaTruck } from "react-icons/fa";
import { setOrderSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import CustomerPicker from '../../components/customer/CustomerPicker';
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi';
import { RxCross1 } from "react-icons/rx";
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi';
import ProductPicker from '../../components/product/ProductPicker';
import DeleteModal from '../../components/DeleteModal';
import { TbReceipt } from "react-icons/tb";
import { FaArrowRotateLeft } from 'react-icons/fa6';
import ChargeModal from '../../components/ChargeModal';

const OrderListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [orderPage, setOrderPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${ORDER_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${ORDER_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.order)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    const [productPage, setProductPage] = useState({
        content: []
    });
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const [isOpenChargeModal, setIsOpenChargeModal] = useState(false)
    const [selected, setSelected] = useState()

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }
    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }
    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    const orderFilters = () => ({ ...searchParams, customerId: searchParams.customer?.id, productId: searchParams.product?.id })

    useEffect(() => {
        loadCustomers({ size: 20 })
        loadOrders({ ...orderFilters(), page: 0 })
        loadProducts({ size: 20 })
    }, [])

    const [customerPage, setCustomerPage] = useState({
        content: []
    });
    const [customerQuery, setCustomerQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)

    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }

    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }

    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    const onLoadMore = () => {
        if (!orderPage.last) {
            loadOrders({ ...orderFilters(), page: orderPage.number + 1 })
        }
    }

    const loadOrders = (params) => {
        !pendingApiCall &&
            getPageOrders(params)
                .then(res => {
                    setOrderPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageOrders(params)
                .then(res => {
                    setOrderPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteOrder(deleteId)
            .then(res => {
                setIsOpen(false)
                setOrderPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const onClickChargeOrder = (order) => {
        if (order.charged) {
            dechargeOrder(order.id)
                .then(res => {
                    setOrderPage(prevState => ({
                        ...prevState,
                        content: prevState.content.map(p => {
                            if (p.id === order.id) return res.data
                            else return p
                        })
                    }))
                    toast.success('Sipariş müşteri hesabından çıkarıldı')
                })
        } else {
            chargeOrder(order.id).then(res => {
                setOrderPage(prevState => ({
                    ...prevState,
                    content: prevState.content.map(p => {
                        if (p.id === order.id) return res.data
                        else return p
                    })
                }))
                toast.success('Sipariş müşteri hesabına eklendi')
            })
        }
        setIsOpenChargeModal(false)
    }

    const onClickReceipt = (order) => {
        downloadOrderReceipt(order.id)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = "" + order.customerName + ` sipariş #${order.id}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    useEffect(() => {
        !isFirstRender && searching({ ...orderFilters(), page: 0 })
    }, [searchParams])

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                date: row[0],
                customerCode: row[1],
                invoiceNumber: row[2],
                vat: row[3],
                cost: row[4],
                description: row[5]
            })
        }
        uploadOrderExcelFile(items)
            .then(res => {
                toast.success("Kayıtlar güncellendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const onClickNewReceipt = (order) => {
        downloadNewOrderReceipt(order.id)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = "" + order.customerName + ` sipariş #${order.id}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    SİPARİŞLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50 z-10'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Sipariş</label>}
                    variant='green'
                    onClick={() => nav('/order/add')}
                />
            </div>
            {/* <label
                className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                htmlFor='excel-upload'
            >
                <RiFileExcel2Fill />
                <span> Excel Yükle</span>
            </label>
            <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            <div className='shadow-lg border rounded-md p-2'>
                <label className='block'>Filtreler</label>
                <div className='grid grid-cols-4 gap-x-3'>
                    <div className='col-span-1'>
                        <ProductPicker
                            className='mb-0'
                            label={`Ürün`}
                            label2='Seçili ürünü içeren siparişler filtrelenir'
                            pendingApiCall={pendingApiCallProduct}
                            state={searchParams.product}
                            setState={(value) => dispatch(setOrderSearchParamsAction({ key: 'product', value }))}
                            query={productQuery}
                            setQuery={setProductQuery}
                            // error={errors.productId}
                            page={productPage}
                            // setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                            onClickClear={() => dispatch(setOrderSearchParamsAction({ key: 'product', value: null }))}
                            onClickLoadMore={() => onClickLoadMoreProduct()}
                        />
                    </div>
                    <div className='col-span-1'>
                        <Input
                            name='boilerCode'
                            label='Kazan no'
                            label2="Kazan no'yu içeren siparişler filtrelenir"
                            placeholder='Kazan no girin...'
                            value={searchParams.boilerCode}
                            onChange={e => dispatch(setOrderSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                        />

                    </div>

                </div>

            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-10 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>
                            <div className='flex justify-between' >
                                <div className='flex gap-x-2'>
                                    <span>
                                        Müşteri Adı
                                    </span>
                                    <span>
                                        {pendingApiCallCustomer && <Spinner />}
                                    </span>
                                </div>
                                {
                                    searchParams.customer &&
                                    <span className='cursor-pointer' onClick={() => dispatch(setOrderSearchParamsAction({ key: 'customer', value: null }))} >
                                        <RxCross1 />
                                    </span>
                                }
                            </div>
                        </th>
                        <th className='p-2 w-1/12'>Tarih</th>
                        <th className='p-2 w-2/12'>Fatura No</th>
                        <th className='p-2 w-1/12'>Kullanıcı</th>
                        <th className='p-2 w-1/12'>Fiyat</th>
                        <th className='p-2 w-1/24'>Hesap</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-16 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setOrderSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <CustomerPicker
                                // pendingApiCall={pendingApiCallCustomer}
                                state={searchParams.customer}
                                setState={(value) => dispatch(setOrderSearchParamsAction({ key: 'customer', value }))}
                                query={customerQuery}
                                setQuery={setCustomerQuery}
                                page={customerPage}
                                //onClickClear={() => setOrderSearchParamsAction({ key: 'customer', value: null })}
                                onClickLoadMore={() => onClickLoadMoreCustomer()}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                type='date'
                                name="orderDate"
                                value={searchParams.orderDate}
                                onChange={e => dispatch(setOrderSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="invoiceNumber"
                                placeholder='Fatura no...'
                                value={searchParams.invoiceNumber}
                                onChange={e => dispatch(setOrderSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>

                    {
                        orderPage.content.map((order, index) => (
                            <tr key={index} className='border-b items-center text-sm hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {order.id} </td>
                                <td className='p-2'>{order.customerName} </td>
                                <td className='p-2'>{formatDate(order.orderDate)} </td>
                                <td className='p-2'>{order.invoiceNumber} </td>
                                <td className='p-2'>{order.user} </td>
                                <td className='p-2'>{order.charged ? `${formatNumber(order.cost)} ${order.currency}` : "-"} </td>
                                <td className='p-2'>
                                    <input
                                        type='checkbox'
                                        checked={order.charged}
                                        //defaultChecked={Boolean(order.charged)}
                                        onChange={() => {
                                            setSelected(order)
                                            setIsOpenChargeModal(true)
                                        }}
                                    />
                                </td>
                                <td className='p-2 items-center'>
                                    {
                                        !order.formerRecord &&
                                        <>
                                            {
                                                <div className='flex gap-x-3'>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-gray-600 duration-150'>
                                                        <FaReceipt onClick={() => onClickReceipt(order)} />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-gray-600 duration-150'>
                                                        <TbReceipt onClick={() => onClickNewReceipt(order)} />
                                                    </span>

                                                    <span className='cursor-pointer hover:scale-125 hover:text-green-600 duration-150' onClick={() => nav(`/order/${order.id}/shipment`)}>
                                                        <FaTruck />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/order/edit/${order.id}`)}>
                                                        <AiFillEdit />
                                                    </span>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-gray-600 duration-150'>
                                                        <FaArrowRotateLeft onClick={() => nav(`/returnment/order/${order.id}`)} />
                                                    </span>
                                                    {
                                                        !order.charged &&
                                                        <>
                                                            <span
                                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                                onClick={() => {
                                                                    setIsOpen(true)
                                                                    setDeleteId(order.id)
                                                                }}
                                                            >
                                                                <AiFillDelete />
                                                            </span>
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={orderPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <ChargeModal
                isOpen={isOpenChargeModal}
                closeModal={() => setIsOpenChargeModal(false)}
                onSubmit={() => onClickChargeOrder(selected)}
            />
        </div>
    )
}

export default OrderListPage